import axios from './requesters/axios';
// import cookie from 'react-cookie';
// import Debug from 'debug';
import Swal from 'sweetalert2';

// import { API_URL } from '../../actions';
import { apiErrorHandler } from './errors';
import {
  HEADER_SUCCESS,
  GENERIC_SUCCESS
} from './constants/messages';

import store from './store/store'
import { configuration } from './configuration'

export const GET_INITIAL_SERVICES = 'GET_INITIAL_SERVICES';
export const FETCHED_SERVICE_CHILDREN = 'FETCHED_SERVICE_CHILDREN';
export const SET_MAINSERVICE_LOADING = 'SET_MAINSERVICE_LOADING';
export const CUSTOM_SERVICE = 'CUSTOM_SERVICE';
export const LOADING_CUSTOM_SERVICE = 'LOADING_CUSTOM_SERVICE';
export const CREATED_SERVICE_SUCCESSFUL = 'CREATED_SERVICE_SUCCESSFUL';
export const EDITED_SERVICE_SUCCESSFUL = 'EDITED_SERVICE_SUCCESSFUL';
export const REMOVED_SERVICE_SUCCESSFUL = 'REMOVED_SERVICE_SUCCESSFUL';
export const FETCHED_PARENT_SERVICES = 'FETCHED_PARENT_SERVICES';
export const SHOW_EXTENSION_MODAL = 'SHOW_EXTENSION_MODAL';
export const FETCHED_CATALOGUE_SERVICE = 'FETCHED_CATALOGUE_SERVICE';
export const MAIN_SERVICE_KM = 'MAIN_SERVICE_KM';
export const SERVICE_NOT_FOUND = 'Ha habido un problema al cargar el servicio seleccionado. Espere unos segundos e inténtelo de nuevo.<br> Si el problema persiste use el servicio "No encuentro lo que necesito" o contacte con nosotros en ';

/**
 * @apiIgnore Internal
 * @apiDescription Generate GET parameters based in Car object
 * @apiSuccess {String} Empty or GET params as string
 */
function __carObjToQuery__(car, carPlate, emailHash) {
  const query = []
  if (car && car.carMake) {
    query.push(`make=${car.carMake}`)
  }
  if (car && car.carModel) {
    query.push(`model=${car.carModel}`)
  }
  if (car && car.carEngine) {
    query.push(`fuel=${car.carEngine.split(",")[1]}`)
  }
  if (car && car.carYear) {
    query.push(`year=${car.carYear}`)
  }
  if (carPlate) {
    query.push(`carPlate=${carPlate}`)
  }
  if (emailHash) {
    query.push(`autocareHash=${emailHash}`)
  }

  if (query.length > 0) {
    return `?${query.join('&')}`
  }
  return ''
}

function getTimeout(defaultValueInMillis = 10000) {
  return configuration().defaultTimeout ? configuration().defaultTimeout : defaultValueInMillis
}

/**
 * @apiIgnore Internal
 * @apiDescription Get all list of the main services or filtered by make.
 * @apiSuccess {Object[]} It contain service list.
 */
export function fetchMainServices(car = null) {
  return dispatch => {
    axios.get(`/services/main${__carObjToQuery__(car)}&clientService=true`)
      .then(response => {
        dispatch({
          type: GET_INITIAL_SERVICES,
          payload: {
            services: response.data,
          }
        })
      })
      .catch((error) => apiErrorHandler(error));
  }
}

/**
 * @apiIgnore Internal
 * @apiDescription Get all list of the children services or filtered by make.
 * @apiSuccess {Object[]} It contain service list.
 */
export function getServiceChildren(service, car = null, carPlate, emailHash) {
  return dispatch => {
    if (service.loadFromIntegration) {
      dispatch({
        type: LOADING_CUSTOM_SERVICE,
        payload: {
        }
      })
    }
    axios.get(`/services/${service.serviceId}/children${__carObjToQuery__(car, carPlate, emailHash)}&clientService=true`, { timeout: getTimeout() })
      .then(response => {
        if (car && car.carMake) {
          response.data = response.data.filter((s) => !s.brand || s.brand === car.carMake)
        }
        if (service.loadFromIntegration) {
          dispatch({
            type: CUSTOM_SERVICE,
            payload: {
            }
          })
        }
        if (service.name === configuration().mainServiceKmName) {
          dispatch({
            type: MAIN_SERVICE_KM,
            payload: {
              mainServiceKm: true
            }
          })
        } else {
          dispatch({
            type: MAIN_SERVICE_KM,
            payload: {
              mainServiceKm: false
            }
          })
        }
        dispatch({
          type: FETCHED_SERVICE_CHILDREN,
          payload: {
            service,
            services: response.data,
          }
        })
      })
      .catch((_) => {
        const state = store.getState();
        Swal.fire({
          html: SERVICE_NOT_FOUND + state.checkout.workshop.phone,
          confirmButtonText: 'Aceptar',
          customClass: {
            confirmButton: 'jump',
            content: 'mazda-modal-content',
          }
        })
        dispatch({
          type: SET_MAINSERVICE_LOADING,
          payload: {
            value: false
          }
        });
      });
  }
}

export function getParentServices(history, car) {
  let actual = history.slice(-1)[0];
  return dispatch => {
    if (history.length > 1) {
      axios.get(`/services/${actual.parent}/children`)
        .then(response => {
          if (history[0].name === configuration().mainServiceKmName) {
            dispatch({
              type: MAIN_SERVICE_KM,
              payload: {
                mainServiceKm: true
              }
            })
          } else {
            dispatch({
              type: MAIN_SERVICE_KM,
              payload: {
                mainServiceKm: false
              }
            })
          }
          dispatch({
            type: FETCHED_PARENT_SERVICES,
            payload: {
              services: response.data,
            }
          })
        })
        .catch((error) => apiErrorHandler(error));
    } else {
      dispatch(fetchMainServices(car));
    }
  }
}

export function createService(values) {
  return (dispatch) => {
    axios.post(`/services`,
      {
        service: values,
      })
      .then(response => {
        dispatch(showModal(false));
        dispatch({
          type: CREATED_SERVICE_SUCCESSFUL,
          payload: {
            service: response.data,
          }
        });
      })
      .catch((error) => apiErrorHandler(error));
  }
}


export function showModal(isVisible, type) {
  return dispatch => dispatch({
    type: SHOW_EXTENSION_MODAL,
    payload: {
      show: isVisible,
      type,
    }
  })
}

export function editService(values) {
  return (dispatch) => {
    axios.post(`/services/${values.serviceId}`, values)
      .then(response => {
        dispatch({
          type: EDITED_SERVICE_SUCCESSFUL,
          payload: {
            service: values,
          }
        });
        dispatch(showModal(false));
      })
      .catch((error) => { });
  }
}

export function deleteService(serviceId) {
  return (dispatch) => {
    axios.delete(`/services/${serviceId}`)
      .then(response => {
        dispatch({
          type: REMOVED_SERVICE_SUCCESSFUL,
          payload: {
            serviceId,
          }
        });
        Swal.fire({
          title: HEADER_SUCCESS,
          text: GENERIC_SUCCESS,
          type: "success"
        });
      })
      .catch((error) => {
        switch (error.response.data.error) {
          case 'hasChildren':
            Swal.fire({
              title: 'Error',
              text: 'No puedes borrar un servicio que contiene a otros servicios.',
              type: 'error'
            });
            break;
          default:
            apiErrorHandler(error);
        }
      });
  }
}

export function renderSearchMainServiceKm(mainServiceKm) {
  return (dispatch) => {
    dispatch({
      type: MAIN_SERVICE_KM,
      payload: {
        mainServiceKm: mainServiceKm
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/catalogue.js